import { render, staticRenderFns } from "./riepilogoOre.html?vue&type=template&id=0bc0fe8a&scoped=true&"
import script from "./RiepilogoOre.vue?vue&type=script&lang=js&"
export * from "./RiepilogoOre.vue?vue&type=script&lang=js&"
import style0 from "./RiepilogoOre.vue?vue&type=style&index=0&id=0bc0fe8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0fe8a",
  null
  
)

export default component.exports